module.exports = __webpack_public_path__ + "static/img/son11_active.57577c18.jpg";